<template>
    <div class="content">
        <app-table id="activity-table" :options="options"/>
    </div>
</template>

<script>
    import CoreLibrary from "../../../../core/helpers/CoreLibrary.js";
    import {formatDateToLocal} from "../../../Helper/Support/DateTimeHelper";
    import {ucFirst} from '../../../Helper/Support/TextHelper'

    export default {
        name: "Activity",
        extends: CoreLibrary,
        components: {
            'app-activity-details': require('./Component/ActivityDetails').default
        },
        props: {
            props: {

            }
        },
        data(){
            return{
                options: {
                    url: this.props?.id ? `admin/user/activities/${this.props.id}` :'admin/user/activity-log',
                    showHeader: true,
                    tableShadow: false,
                    showManageColumn: false,
                    tablePaddingClass: 'px-0 py-primary',
                    columns: [
                        {
                            title: this.$t('title'),
                            type: 'custom-html',
                            key: 'description',
                            modifier: (description) => {
                                if (!description) return description;

                                const hasTranslation = (key) => {
                                    const translated = this.$t(key);
                                    return translated && translated !== key;
                                };

                                const translateDefaultKey = (value) => value.replace(
                                    /default\.([a-z0-9_]+)/gi,
                                    (_, key) => hasTranslation(key) ? this.$t(key) : key
                                );

                                return translateDefaultKey(description)
                                    .replace(/\bhas been Created\b/g, 'has been created')
                                    .replace(/\bhas been Updated\b/g, 'has been updated')
                                    .replace(/\bhas been Deleted\b/g, 'has been deleted')
                                    .replace(/đã là Tạo/g, 'đã được tạo')
                                    .replace(/đã là cập nhật/g, 'đã được cập nhật')
                                    .replace(/đã là xóa/g, 'đã bị xóa');
                            }
                        },
                        {
                            title: this.$t('name'),
                            type: 'custom-html',
                            key: 'subject',
                            modifier: (subject, activity) => {
                                const hasTranslation = (key) => {
                                    const translated = this.$t(key);
                                    return translated && translated !== key;
                                };

                                const getSubjectTypeLabel = (subjectType) => {
                                    if (!subjectType) return '';
                                    const className = subjectType.split('\\').pop();
                                    const translationKey = className
                                        .replace(/([a-z0-9])([A-Z])/g, '$1_$2')
                                        .toLowerCase();

                                    return hasTranslation(translationKey) ? this.$t(translationKey) : className;
                                };

                                if (subject)
                                    return (subject.name ? ucFirst(this.$t(subject.name)) : '') ||
                                        subject.full_name ||
                                        subject.subject ||
                                        getSubjectTypeLabel(activity?.subject_type);
                                let attributes = this.$optional(activity, 'properties', 'attributes');
                                let old = this.$optional(activity, 'properties', 'old');
                                if (attributes && Object.keys(attributes).length) {
                                    return (attributes.name || attributes.full_name) ||
                                        attributes.subject ||
                                        getSubjectTypeLabel(activity?.subject_type);
                                }else if(old && Object.keys(old).length){
                                    return (old.name || old.full_name) ||
                                        old.subject ||
                                        getSubjectTypeLabel(activity?.subject_type);
                                }

                                return getSubjectTypeLabel(activity?.subject_type);
                            }
                        },
                        {
                            title: this.$fieldTitle('time'),
                            type: 'custom-html',
                            key: 'created_at',
                            modifier: created_at => formatDateToLocal(created_at, true)
                        }
                    ],
                    filters: [

                    ],
                    paginationType: "loadMore",
                    responsive: true,
                    rowLimit: 10,
                    showAction: false,
                    orderBy: 'desc',
                }
            }
        }
    }
</script>
